var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 77,
    viewBox: "0 0 101 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_107_2310)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.6377,
    cy: 31,
    r: 24,
    transform: "rotate(20 69.6377 31)",
    fill: "#26BFBF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1937 40.0325C70.7249 40.2174 71.2551 40.3579 71.7842 40.4538C72.3133 40.5498 72.8315 40.5978 73.3388 40.5979L72.7394 43.6982C72.1209 43.6373 71.488 43.5383 70.8409 43.4013C70.1937 43.2642 69.5504 43.0844 68.911 42.8618C67.7009 42.4406 66.6509 41.8766 65.7609 41.1697C64.8808 40.4662 64.1933 39.6368 63.6986 38.6815C63.2074 37.7164 62.9367 36.6405 62.8865 35.4539C62.8496 34.2608 63.0742 32.9658 63.5605 31.5689L65.3019 26.5664C65.8019 25.1301 66.4402 23.946 67.2168 23.0141C68.0067 22.0758 68.9022 21.3728 69.9032 20.9051C70.9141 20.4408 71.9945 20.2047 73.1443 20.1969C74.304 20.1925 75.5085 20.4077 76.7579 20.8426C77.3678 21.0549 77.9427 21.3047 78.4825 21.5918C79.0355 21.8726 79.5782 22.1829 80.1107 22.5226L78.6503 25.3397C78.2688 25.0415 77.8377 24.759 77.3569 24.4924C76.886 24.2292 76.3948 24.0086 75.8833 23.8305C75.1258 23.5668 74.4027 23.442 73.714 23.4559C73.0351 23.4733 72.4037 23.6395 71.8197 23.9546C71.2392 24.2599 70.7108 24.7323 70.2345 25.3716C69.7681 26.0145 69.3619 26.8327 69.0161 27.8263L67.2644 32.8582C66.922 33.842 66.7423 34.7225 66.7254 35.4997C66.7218 36.2706 66.8545 36.9509 67.1234 37.5409C67.3957 38.121 67.7911 38.6171 68.3094 39.0292C68.8376 39.4446 69.4657 39.7791 70.1937 40.0325ZM74.5249 29.0159L73.8212 31.0376L62.2816 27.0206L62.9853 24.999L74.5249 29.0159ZM73.1482 32.9707L72.4445 34.9923L60.9049 30.9754L61.6087 28.9537L73.1482 32.9707Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_107_2310)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.6376,
    cy: 45,
    r: 24,
    transform: "rotate(-19.5113 30.6376 45)",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3442 30.3155L27.9664 34.6967L25.7099 35.5322L24.0876 31.151L26.3442 30.3155ZM34.9256 54.3466L36.3796 58.2735L34.1378 59.1036L32.6837 55.1767L34.9256 54.3466ZM35.3858 48.7945C35.176 48.2279 34.8761 47.778 34.4861 47.4448C34.1023 47.0981 33.5882 46.8497 32.9439 46.6995C32.2959 46.5396 31.4812 46.4691 30.4997 46.4882C29.0865 46.5116 27.8098 46.4234 26.6695 46.2236C25.5353 46.0104 24.5592 45.5943 23.7413 44.9752C22.9295 44.3427 22.2975 43.4159 21.8454 42.1949C21.4005 40.9933 21.2888 39.8517 21.5103 38.77C21.7416 37.6847 22.2619 36.72 23.0713 35.876C23.8807 35.032 24.9448 34.3659 26.2636 33.8776C27.2795 33.5014 28.2489 33.3147 29.1718 33.3173C30.1045 33.3163 30.9675 33.5021 31.7609 33.8748C32.5542 34.2476 33.2615 34.8077 33.8826 35.5552C34.5099 36.2893 35.0279 37.2083 35.4366 38.3121L31.9199 39.6142C31.6884 38.989 31.409 38.4594 31.0816 38.0252C30.7604 37.5776 30.3997 37.2335 29.9996 36.9929C29.5959 36.7425 29.1643 36.5969 28.7048 36.556C28.2551 36.5114 27.7861 36.5796 27.2976 36.7604C26.6041 37.0172 26.0814 37.3607 25.7298 37.7908C25.3744 38.2112 25.1725 38.6858 25.124 39.2148C25.0852 39.7401 25.1726 40.2909 25.386 40.8672C25.5921 41.424 25.8804 41.8727 26.2509 42.2132C26.6213 42.5536 27.1287 42.799 27.773 42.9492C28.4235 43.086 29.2712 43.1553 30.316 43.1572C31.7425 43.14 33.018 43.2398 34.1424 43.4566C35.273 43.66 36.2374 44.0749 37.0359 44.7012C37.8404 45.3141 38.4688 46.2311 38.9209 47.4522C39.3875 48.7124 39.4905 49.8905 39.2299 50.9867C38.9791 52.0793 38.4161 53.0486 37.5408 53.8948C36.6717 54.7275 35.5485 55.3989 34.1712 55.9089C33.3018 56.2308 32.3956 56.4386 31.4528 56.5322C30.5162 56.6124 29.6034 56.5172 28.7145 56.2465C27.8256 55.9758 27.0151 55.4817 26.2829 54.7642C25.5471 54.037 24.9441 53.0384 24.4739 51.7685L28.0198 50.4555C28.302 51.2175 28.6396 51.8144 29.0329 52.2464C29.4261 52.6785 29.8528 52.9759 30.313 53.1387C30.7731 53.3016 31.2416 53.3669 31.7185 53.3348C32.2051 53.299 32.6682 53.1997 33.1078 53.0369C33.8404 52.7657 34.4106 52.4157 34.8184 51.987C35.2323 51.5449 35.4831 51.0522 35.5707 50.5088C35.6644 49.952 35.6028 49.3806 35.3858 48.7945Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_107_2310",
    x: 33.8766,
    y: -2.76111,
    width: 71.5222,
    height: 71.5222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_2310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_2310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_107_2310",
    x: -5,
    y: 11.3624,
    width: 71.2753,
    height: 71.2753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_2310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_2310",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.78512d8090d48d56bcc66305f4fd59c4.svg";
export { ForwardRef as ReactComponent };